import 'phaser'

import { IV } from '../lib/IV'
import { createId } from '../main/common'
import { layers } from '../main/layers-sidecar'
import { rando } from './../lib/rando-sidecar'
import { spriteMap } from './../main/spriteMap-sidecar'
import { IEntity } from './entitiesUtils'
import { entitiesUtils } from './entitiesUtils-sidecar'
import { IParticleData, ParticleType } from './particlesData'
import { particlesData } from './particlesData-sidecar'

export interface IParticle extends IEntity {
  type: ParticleType
  image: Phaser.GameObjects.Image
  data: IParticleData
  dir: IV
  speed: number
  framesLeft: number
  angle: number
  angleSpeed: number
}

const objs: IParticle[] = []

export function findById(id: number) {
  return entitiesUtils.findById(id, objs)
}

export function createGroup(type: ParticleType, x: number, y: number) {
  let num = rando.i(2, 6)
  for (let i = 0; i < num; i++) {
    create(type, x, y)
  }
}

export function create(type: ParticleType, x: number, y: number): IParticle {
  let id = createId()
  let data = particlesData.dataMap[type]

  let image = spriteMap.createImageFromFrameInfo(
    layers.getLayers().particles,
    data.frameInfo,
    x,
    y,
  )

  let obj: IParticle = {
    eType: 'particle',
    id,
    type: type,
    image,
    data,
    isDead: false,
    dir: rando.vec(),
    speed: rando.f(15, 150),
    framesLeft: rando.i(15, 60),
    angle: rando.f(0, Math.PI),
    angleSpeed: rando.f(-1, 1),
  }
  objs.push(obj)

  return obj
}

export function kill(obj: IParticle) {
  obj.isDead = true
  obj.image.tint = 0xccc
}

export function updateAll() {
  objs.forEach((c) => {
    update(c)
  })
  entitiesUtils.removeDead(objs, (c) => {
    c.image.destroy()
  })
}
function update(obj: IParticle) {
  let dx = (obj.dir.x * obj.speed) / 100
  let dy = (obj.dir.y * obj.speed) / 100

  obj.angle += (obj.angleSpeed * (2 * Math.PI)) / 60
  obj.image.rotation = obj.angle
  obj.image.x += dx
  obj.image.y += dy
  obj.framesLeft--
  if (obj.framesLeft < 0) {
    kill(obj)
  }
}
